<template>
  <v-container>
    <v-card v-if="showIntro">
      <v-card-text class="text-h6">
        Just ahead of you are fifteen questions that let me know a little bit more about you.<br><br>
        Answer them truthfully, and discover what type of Pokémon suits you best!
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          color="success"
          class="mb-8"
          @click="showIntro = false"
        >
          Ok, Let's Go!
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else-if="!display && !showIntro">
      <v-card-title class="text-h5">Personality Quiz</v-card-title>
      <v-divider />
      <v-card-text>
        <div>
          <v-card
            flat
            width="100%"
          >
            <v-card-title> {{ selectedQuestion.text }} </v-card-title>
            <v-card-actions>
              <v-radio-group v-model="answer">
                <v-radio
                  v-for="(choice, index) in selectedQuestion.choices"
                  :key="index"
                  :label="choice"
                  :value="index"
                />
              </v-radio-group>
            </v-card-actions>
          </v-card>
          <v-pagination
            v-model="page"
            :length="questions.length"
            :total-visible="10"
            class="mt-8"
          />
        </div>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-card-title>Quiz Result</v-card-title>
      <v-card-text>
        <h2 class="text-center">You seem to be... {{ display }} type!</h2>
        <br>
        <div>
          {{ responses[display] }}
        </div>
      </v-card-text>
    </v-card>
    <v-btn
      v-if="page === questions.length"
      color="success"
      class="mt-12"
      block
      @click="submit"
    >
      Submit Quiz
    </v-btn>
    <v-snackbar
      v-model="snackbar"
      color="error"
    >
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-btn
      v-if="display"
      class="mt-12"
      block
      @click="reset"
    >
      Take the quiz again
    </v-btn>
  </v-container>
</template>

<script>
import Questions from './QuestionBank'
import Responses from './Responses'
export default {
  name: 'Quiz',
  components: {

  },
  data: () => ({
    questions: Questions,
    responses: Responses,
    page: 1,
    showIntro: true,
    answer: null,
    display: null,
    snackbar: false,
    error: null,
    results: [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]
  }),
  watch: {
    answer () {
      this.results[this.page-1] = this.answer
    },
    selectedQuestion () {
      this.answer = this.results[this.page-1]
      this.snackbar = false
    }
  },
  computed: {
    selectedQuestion () {
      return this.questions[this.page-1]
    }
  },
  methods: {
    submit () {
      const tally = {
        'Normal': 0,
        'Fire': 0,
        'Water': 0,
        'Grass': 0,
        'Electric': 0,
        'Ice': 0,
        'Fighting': 0,
        'Poison': 0,
        'Ground': 0,
        'Flying': 0,
        'Psychic': 0,
        'Bug': 0,
        'Rock': 0,
        'Ghost': 0,
        'Dark': 0,
        'Dragon': 0,
        'Steel': 0,
        'Fairy': 0
      }
      for (let [index, result] of this.results.entries()) {
        if (result < 0) {
          this.error = `Question #${index+1} has not been answered yet!`
          this.snackbar = true
          return
        }
        const types = this.questions[index].values[result]
        for (const type of types){
          tally[type] += 1
        }
      }
      // Output
      let winners = []
      let winningValue = Math.max(...Object.values(tally))

      for (const type of Object.keys(tally)) {
        if (tally[type] === winningValue) {
          winners.push(type)
        }
      }
      this.page = 1
      this.display = winners[0]
    },
    reset () {
      this.display = null
      this.answer = null
      this.results = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]
    }
  }
};
</script>
